import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

/** Profico mark — the wordmark's "p" in brand blue on a near-black tile. */
export function BrandMark({ size = 24, className, tile = false }) {
  return (
    <span
      aria-hidden="true"
      className={cn('inline-flex items-center justify-center flex-shrink-0 select-none', className)}
      style={{
        width: size,
        height: size,
        borderRadius: tile ? Math.round(size * 0.24) : undefined,
        background: tile ? '#0D0D0F' : undefined,
        color: '#0099FF',
        fontFamily: 'Roobert, Inter, system-ui, sans-serif',
        fontWeight: 700,
        fontSize: Math.round(size * 0.58),
        lineHeight: 1,
      }}>
      p
    </span>
  );
}

/** Profico Labs wordmark — lowercase "profico" (Roobert Bold) + "Labs" label. */
export function ProficoWordmark({ className, markSize = 26, showMark = true, sub = 'Labs' }) {
  return (
    <span className={cn('inline-flex items-center gap-2.5 min-w-0', className)}>
      {showMark ? <BrandMark size={markSize} tile /> : null}
      <span className="flex flex-col leading-none text-left min-w-0">
        <span className="font-display text-[17px] font-bold tracking-[-0.03em] lowercase text-ink">profico</span>
        {sub ? (
          <span className="text-[10px] font-semibold mt-0.5 uppercase tracking-[0.22em] text-mute">{sub}</span>
        ) : null}
      </span>
    </span>
  );
}

/** Profico Labs lockup. */
export default function BrandLockup({
  to = '/dashboard',
  collapsed = false,
  className,
  markSize = 26,
  asLink = true,
  sub = 'Labs',
}) {
  const content = collapsed ? (
    <BrandMark size={markSize} tile />
  ) : (
    <ProficoWordmark markSize={markSize} sub={sub} />
  );

  if (!asLink) {
    return (
      <span className={cn('inline-flex items-center', className)} aria-label="Profico Labs">
        {content}
      </span>
    );
  }

  return (
    <Link to={to} className={cn('inline-flex items-center no-underline', className)} aria-label="Profico Labs">
      {content}
    </Link>
  );
}
